export default {
	selectOptions: {
		plants: [],
		pgmIds: [],
		procIds: []
	},

	searchParams: {
		plantCd: 'ALL',
		pgmId: 'ALL',
		procId: 'ALL'
	},

	pagingInfo: {
		currentPage: 1,
		pageUnit: 20
	},

	processes: [],

	isControllable: false,

	controlUser: {
		userId: null,
		userName: ''
	}
};
